// Help Hub is a colleague-facing app that authenticates directly against
// Azure AD / Microsoft Teams via NextAuth (see `auth/auth.ts`). The workspace
// lint rule `@typescript-eslint/no-restricted-imports` steers apps towards
// `@onyx/session`, but that library implements the customer-facing CIAM flow
// (`useAuthSession` / `AuthSessionProvider`) and is not a drop-in replacement
// for this app's Azure AD colleague flow.
//
// To keep the suppression in a single, documented place instead of scattering
// `eslint-disable` comments across components, the NextAuth React client is
// re-exported here. Import `useSession` / `signOut` from this module.
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
export { signOut, useSession } from 'next-auth/react';
